module.exports = __webpack_public_path__ + "static/media/international-refund-application.bd33a40b.pdf";